import React from 'react';
import { Container, Row} from 'react-bootstrap';
import FaqCard from './FaqCard';

import FaqIcon1 from '../../assets/img/title-icon.png';

const questions = [
    {
        no: "01",
        title: "哪裡可以看到路線呢？",
        ans: "請詳見本官網 ➜「挑戰賽路線」；伊貝特點擊「挑戰賽路線」，即可參考不同路線的海拔圖，亦可從本官網下載GPX檔，將路線下載至手機。（下載教學請參見挑戰賽路線）",
    },
    {
        no: "02",
        title: "這些路線都是經由環法官方認證的嗎？",
        ans: "是的。本次活動103K路線與28K路線，皆為經由環法官方專家認證賽道，亦符合環法規定爬坡計算分級。",
    },
    {
        no: "03",
        title: "本次活動會全程封路且有交通管制嗎？",
        ans: "本活動採滾動式封路，103K競賽計時組將全程有專車護送。103K中途關門點為台21線甲線20K+815頭社派出所前路口，關門時間11:00，逾時者請直接折返向山會場；103K終點關門時間依出發波次為12:00～12:20（6小時），28K為10:30～10:50（4小時）。關門時間過後，後續的原活動路段的交維志工將撤哨，結束服務。",
    },
    {
        no: "04",
        title: "補給站的位置在哪？",
        ans: "103K 挑戰組：補給站：32K、57.5K、69.5K；技術服務站：32K、57.5K、69.5K。28K：沿途無設置補給站，建議車手可視自身情況攜帶補給品與能量飲食。",
    },
    {
        no: "05",
        title: "選手手冊什麼時候可以下載？",
        ans: "選手手冊最慢將於活動開始前一個月公布與開放下載，敬請期待。",
    },
    {
        no: "06",
        title: "哪裡可以看到活動當天的會場配置圖？",
        ans: "主會場地圖仍在研擬中，待確認後將公告在「活動辦法」頁面。",
    },
]

const questionsEng = [
    {
        no: "01",
        title: "Where can I see the routes?",
        ans: "See the 'Event Route' page on this website ➜ or click 'Event Route' on the Ebet registration page to view the elevation profile of each route. You can also download the GPX files from this website to your phone. (See the Event Route page for download instructions.)",
    },
    {
        no: "02",
        title: "Are these routes officially certified by the Tour de France?",
        ans: "Yes. Both the 103K and 28K routes have been certified by official Tour de France experts, and the climbs are categorized according to Tour de France rules.",
    },
    {
        no: "03",
        title: "Will roads be fully closed, with traffic control, during the event?",
        ans: "The event uses rolling road closures, and the 103K timed competitive group will be escorted by dedicated vehicles along the entire course. The 103K intermediate cut-off is 11:00 at the junction in front of Toushe Police Station (Provincial Highway 21A, 20K+815); riders who miss it must ride straight back to the Xiangshan venue. The 103K finish cut-off is 12:00-12:20 depending on start wave (6 hours), and the 28K finish cut-off is 10:30-10:50 depending on start wave (4 hours). After the cut-off time, traffic control volunteers along the remaining route will stand down and end their service.",
    },
    {
        no: "04",
        title: "Where are the aid stations?",
        ans: "103K The Race: Aid Stations at 32K, 57.5K, and 69.5K; Technical Support Stations at 32K, 57.5K, and 69.5K. 28K The Ride: There are no aid stations along the route, so riders are advised to carry their own food, drinks, and energy supplies as needed.",
    },
    {
        no: "05",
        title: "When can I download the participant handbook?",
        ans: "The participant handbook will be published and available for download no later than one month before the event. Stay tuned!",
    },
    {
        no: "06",
        title: "Where can I find the venue layout for event day?",
        ans: "The main venue map is still being finalized and will be posted on the 'Event Guide' page once confirmed.",
    },
]


const RouteQ = ({language}) => {
    return (
        <section className="faq-route">
            <Container>
                <Row className='align-items-center faq-section'>
                    <h2 className='faq-header'><span><img className='faq-icon' src={FaqIcon1} alt="" /></span>{language === "Chinese" ? "路線與活動資訊相關問題" : "Routes and Event Information"}</h2>
                    {language === "Chinese" ? 
                        questions.map((q, index) => (
                            <FaqCard
                                key={index}
                                {...q}
                            />
                        ))
                    : 
                        questionsEng.map((q, index) => (
                            <FaqCard
                                key={index}
                                {...q}
                            />
                        ))
                    }
                </Row>
            </Container>
        </section>
    )
}

export default RouteQ